<template>
  <!--性格测试MBTI-->
  <div class="container">
    <!-- <div class="nav">
        <img src="../assets/img/08.png" class="img01" @click="goHome()" alt="">
        <div>MBTI人格测试</div>
    </div> -->
    <div class="bg">
      <div class="div1">
        <div class="text">{{ index + 1 }}/{{ answerArr.length }}</div>

        <el-progress :percentage="percentage" color="#5F50FF" text-color="#000000" :show-text="false"
                     class="pro1"></el-progress>
        <!-- <div class="pro">
    <div class="pro-1"></div>
  </div> -->
      </div>
      <div class="div2">请仔细阅读下列问题，选择你的认同态度</div>

      <div class="div3">
        <div class="div3-1"></div>
        <div class="div3-2">
          <div class="div-2-1">
            {{ answerArr[index]?.question }}
          </div>
          <div v-for="(item, index) in textArr" :key="index" class="item"
               :class="{ 'itemActive': item.value == num }" @click="getitemActive(item.value)">{{ item.text }}
          </div>
        </div>
      </div>
      <!-- -->
      <div class="btn" @click="pre()" v-if="((index + 1) < answerArr.length) && index != 0">上一题</div>
      <!-- <div class="btn" @click="next()"  v-if="((index + 1) < answerArr.length) && index != 59">下一题</div> -->
      <div class="btn" @click="submit()" v-if="(index + 1) == answerArr.length">提交</div>
    </div>

  </div>
</template>

<script>
import {problemMbti} from "@/api/api.js";
// import { Result } from "element-ui";
export default {
  name: 'HelloWorld',
  data() {
    return {
      textArr: [],
      answerArr: [],
      resultArr: [],
      index: 0,
      num: -1,
      percentage: 1

    }
  },
  mounted() {
    this.getAnswer()
  },
  methods: {
    // 返回首页
    goHome() {
      this.$router.push({
        name: "home",

      });
    },
    //获取问题
    getAnswer() {
      let data = {act: "init"}
      problemMbti(data).then((res) => {
        console.log(res)
        //  this.answerArr = res.data.result.slice(0,5);
        this.answerArr = res.data.result;
        this.textArr = [{value: this.answerArr[this.index].type1, text: this.answerArr[this.index].answer1},
          {value: this.answerArr[this.index].type2, text: this.answerArr[this.index].answer2}]

      });
    },
    // 上一题
    pre() {
      if (this.index != 0) {
        this.num = -1;
        this.index--;
        // 更换选项列表
        this.textArr = [{value: this.answerArr[this.index].type1, text: this.answerArr[this.index].answer1},
          {value: this.answerArr[this.index].type2, text: this.answerArr[this.index].answer2}]
        this.percentage = parseInt((((this.index + 1) / this.answerArr.length)) * 100);

      }
    },
    // 更换背景，保存选项
    getitemActive(index) {
      this.num = index;
      this.resultArr[this.index] = index;
      if ((this.index + 1) < this.answerArr.length) {
        this.num = -1;
        this.index++;
        // 更换选项列表
        this.textArr = [{value: this.answerArr[this.index].type1, text: this.answerArr[this.index].answer1},
          {value: this.answerArr[this.index].type2, text: this.answerArr[this.index].answer2}]
        this.percentage = parseInt((((this.index + 1) / this.answerArr.length)) * 100);
      }
      console.log(this.resultArr)
    },

    submit() {
      this.$router.push({
        name: "resultMBTI",
        params: {
          resultArr: this.resultArr
        },
        query: {
          uid: this.$route.query.uid || 0,
          token: this.$route.query.token || 0,
          env: this.$route.query.env || 0,
        }
      });

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Group 2070 */
.pro1 {
  width: 2.8rem;
  height: 0.3rem;
  margin-top: 0.18rem;
}

.div3 {
  width: 3.37rem;
  margin: 0.3rem auto 0rem;
}

.btn {
  width: 1.32rem;
  height: 0.42rem;
  background: rgba(88, 86, 254, 1);
  text-align: center;
  line-height: 0.42rem;
  border-radius: 6px 0px 0px 0px;
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 600;
  margin: 0.3rem auto;
  color: rgba(255, 255, 255, 1);
  border-radius: 0.1rem;

}

.item {
  width: 2.47rem;
  /* min-height: 0.48rem; */
  background-color: rgba(248, 248, 248, 1);
  /* line-height: 0.48rem; */
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 400;
  /* line-height: 0.4rem; */
  text-align: center;
  border-radius: 0.1rem;
  margin: 0.13rem auto;
  padding: 0.15rem 0.15rem;
}

.itemActive {
  background-image: linear-gradient(90deg, #7370FE 0%, #5856FE 100%);
  color: white;
}

.div3 .div3-2 .div-2-1 {
  width: 2.88rem;
  font-size: 16px;
  line-height: 0.2rem;
  margin: 0px auto;
  font-weight: 600;
  text-align: left;

}


.div3 .div3-2 {
  width: 2.8rem;

  background-color: white;
  margin: 0px auto;
  border-radius: 0px 0px 0.2rem 0.2rem;
  padding: 0.2rem;
}

.div3 .div3-1 {
  width: 3.37rem;
  height: 0.11rem;
  background-image: linear-gradient(to right, rgba(197, 191, 249, 1), rgba(150, 144, 254, 1));
  border-radius: 0.3rem;
}

.div2 {
  font-size: 14px;
  color: rgba(102, 102, 102, 1);
  width: 3.37rem;
  margin: 0.1rem auto;
}

/* 进度 */
.div1 {
  width: 3.37rem;
  height: 0.3rem;
  display: flex;
  align-items: center;

  padding-top: 0.3rem;
  margin: 0px auto;
}

.bg {
  width: 100%;
  background-image: url("../assets/img/13.png");
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0px;
  bottom: 0px;
}

.div1 .text {
  width: 0.39rem;
  height: 0.3rem;
  font-size: 16px;
  margin-right: 0.15rem;
  line-height: 0.3rem;
  color: rgba(153, 153, 153, 1);;
}

.div1 .pro {
  width: 2.73rem;
  height: 0.1rem;
  background-color: rgba(189, 197, 255, 1);
  border-radius: 0.3rem;
}

.div1 .pro .pro-1 {
  width: 1.73rem;
  height: 0.1rem;
  border-radius: 0.3rem;
  background-color: rgba(88, 86, 255, 1);

}

/* 导航 */
.nav {
  height: 0.44rem;
  display: flex;
  align-items: center;
}

.nav div {
  width: 100%;
  font-size: 22px;
  text-align: center;
  position: relative;
  line-height: 0.44rem;
  text-align: center;
}

.img01 {
  width: 0.22rem;
  position: absolute;
  left: 0.15rem;
  z-index: 3;
}
</style>